import { useEffect, useRef, useState } from "react";
import { applyThemeFromTelegram, tgWebApp } from "./lib/tg";
import { detectMode, getInitialResourceLaunch, type Mode } from "./lib/mode";
import DriverMode from "./modes/driver";
import SponsorMode from "./modes/sponsor";
import EndUserMode from "./modes/enduser";
import LoadingScreen from "./ui/LoadingScreen";
import AutoOpenOverlay from "./ui/AutoOpenOverlay";
import ErrorScreen from "./ui/ErrorScreen";

export default function App() {
  const initialResourceLaunch = useRef(getInitialResourceLaunch()).current;
  const [ready, setReady] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [mode, setMode] = useState<Mode>("enduser");
  const [me, setMe] = useState<any>(null);
  const [flowToken, setFlowToken] = useState<string | undefined>(initialResourceLaunch?.flowToken);
  const [autoOpenResourceId, setAutoOpenResourceId] = useState<number | undefined>(
    initialResourceLaunch?.resourceId,
  );

  useEffect(() => {
    const wa = tgWebApp();
    wa?.ready();
    wa?.expand();
    applyThemeFromTelegram();
    wa?.onEvent?.("themeChanged", applyThemeFromTelegram);
    detectMode()
      .then((r) => {
        setMode(r.mode);
        setMe(r.me);
        setFlowToken(r.flowToken);
        setAutoOpenResourceId(r.autoOpenResourceId);
        setReady(true);
      })
      .catch((e) => setError(e.message ?? "unknown"));
    return () => {
      wa?.offEvent?.("themeChanged", applyThemeFromTelegram);
    };
  }, []);

  if (error) return <ErrorScreen message={error} />;
  if (!ready) return initialResourceLaunch ? <AutoOpenOverlay /> : <LoadingScreen />;

  if (mode === "driver") return <DriverMode me={me} />;
  if (mode === "sponsor") return <SponsorMode me={me} />;
  return <EndUserMode flowToken={flowToken} autoOpenResourceId={autoOpenResourceId} />;
}
